import { Component, OnInit, Input } from '@angular/core';
import { Personal } from '../../../../models/Personal.model';
import { Contract } from '../../../../models/Contract.model';
import { Emergency } from '../../../../models/Emergency.model';
import { Payment } from '../../../../models/Payment.model';
import * as _ from 'lodash';
import { CommonHelper } from '../../../../shared/helpers/CommonHelper';

@Component({
  selector: 'app-consultant-card',
  templateUrl: './consultant-card.component.html',
  styleUrls: ['./consultant-card.component.css']
})
export class ConsultantCardComponent implements OnInit {

  @Input()
  archive;
  personal: Personal;
  personalArray = []
  contract: Contract;
  contractArray = []; 
  emergency: Emergency;
  emergencyArray = [];
  payment: Payment;
  paymentArray = [];

  constructor(private commonHelper:CommonHelper) { }

  ngOnInit() {
    this.buildObjects();
  }

  buildObjects(){
    this.personal = this.archive.info.personal;
    this.contract = this.archive.info.contract;
    this.emergency = this.archive.info.emergency;
    this.payment = this.archive.info.payment;
    this.personalArray = this.objectToArray(this.personal);
    this.contractArray = this.objectToArray(this.contract);
    this.emergencyArray = this.objectToArray(this.emergency);
    this.paymentArray = this.objectToArray(this.payment);
  }

  objectToArray(object){
    return _.map(object, (value,prop)=>{
      let val = value;
      let type="string";

      switch(prop){
        case "sex": 
          {val = this.commonHelper.transcriptSex(value);break;}

        case 'civilStatus': 
          {val = this.commonHelper.transcriptCivilStatus(value);break;}

        case 'kind': 
          {val = this.commonHelper.transcriptContractType(parseInt(value));console.log(value);break;}

        case 'honorarium': 
          {val = this.commonHelper.transcriptHonorariumType(value);break;}

        case 'paymentType': 
          {val = this.commonHelper.transcriptPaymentType(value);break;}

        case 'partnership': 
          {val = this.commonHelper.transcriptPartnershipType(value);break;}

        case 'contractStatus': 
          {val = this.commonHelper.transcriptContractStatus(value);break;}

        case 'taxRegime': 
          {val = this.commonHelper.transcriptTaxRegime(value);break;}

        case 'type': 
          {val = this.commonHelper.transcriptContactType(value);break;}
        case "end": {type="date";break;}
        case "begin": {type="date";break;}
        case "born": {type="date";break;}
        case "totalValue": {type="currency";break;}
        case "hourValue": {type="currency";break;}
        case "soldHourValue": {type="currency";break;}

      }

      return {value:val,prop:prop,type:type}
    })
  }

  getVerboseField(name){
    return _.find(this.commonHelper.getConsultantVerboseFields(),{name:name});
  }


}



// WEBPACK FOOTER //
// ./src/app/views/archive/archive/consultant-card/consultant-card.component.ts